module.exports = __webpack_public_path__ + "img/ratio.66df8220.svg";